import {text_mod_2, } from "../text/Text.js";
export const module02 = {
  title:
    "§2. Українська абетка",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_2, },
    ]
  }
